<template>
	<el-cascader :value="value1" :placeholder="placeholder" :options="shengshiqu" @change="Change" separator=" " filterable :props="{multiple: true }"></el-cascader>
</template>

<script>
	import dizhiku from '../plugins/dizhiku.js'
	export default {
		data() {
			return {
				shengshiqu: [],	
				value1:[]
			}
		},
		props: {
			value: {
				type: Array,
				default(){
					return []
				}
			},
			liandong:{
				type:[String,Number],
				default: 3
			},
			placeholder:{
				type:[String],
				default: '请选择省市区'
			}
		},
		mounted() {
			this.CSH()
			
		},
		methods: {
			CSH() {
				var l = 0;
				for (var i in dizhiku.sheng) {
					this.shengshiqu.push({
						value: i,
						label: dizhiku.sheng[i],
						children: this.Shi(i)
					});
				}
				for(var ii in this.value){
					this.value1.push([this.value[ii][0],this.value[ii][1]]);
				}				
			},
			Shi(qishi) {
				if(this.liandong<2){
					return '';
				}
				var lie = [];
				var l = 0;
				var ll = 0;
				qishi = Number(qishi);
				for (var i in dizhiku.shi) {
					qishi += 100;
					l++;
					if (dizhiku.shi[qishi]) {
						lie[ll++] = {
							value: qishi,
							label: dizhiku.shi[qishi],
							children: this.Qu(qishi)
						};
					} else if (l >= 100) {
						break;
					}
				}
				return lie;
			},
			Qu(qishi) {
				if(this.liandong<3){
					return '';
				}
				var lie = [];
				var l = 0;
				var ll = 0;
				qishi = Number(qishi);
				for (var i in dizhiku.qu) {
					qishi += 1;
					l++;
					if (dizhiku.qu[qishi]) {
						lie[ll++] = {
							value: qishi,
							label: dizhiku.qu[qishi]
						};
					} else if (l >= 100) {
						break;
					}
				}
				return lie;
			},
			Change(e) {				
				for(var i in e){						
					if(this.liandong==2){					
						e[i][this.liandong]=dizhiku.shi[e[i][1]]
					}else if(this.liandong==3){
						e[i][this.liandong]=dizhiku.shi[e[i][2]]					
					}
				}			
				this.$emit('input',e)
				
			},

		}
	}
</script>

<style>


</style>
